import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ArticleGrid from './components/ArticleGrid';
import CTASection from './components/CTASection';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';

const SITE_URL = 'https://cssspreadsheet.autos';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: SITE_URL,
      name: 'CSSBuy Spreadsheet',
      description: 'The ultimate resource hub for CSSBuy shopping spreadsheets. Discover free templates, expert guides, product tracking tools, and comparison resources for smarter online shopping.',
      inLanguage: 'en',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${SITE_URL}/?s={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      '@id': `${SITE_URL}/#organization`,
      name: 'CSSBuy Spreadsheet',
      url: SITE_URL,
      description: 'Comprehensive CSSBuy spreadsheet resource hub providing free templates, shopping guides, product tracking tools, and comparison resources.',
      sameAs: [
        'https://kaspreadsheet.com',
      ],
    },
  ],
};

export default function Home() {
  return (
    <main>
      <SchemaOrg data={homeSchema} />
      <Navbar />
      <Hero />
      <CategoryGrid />
      <AboutSection />
      <ArticleGrid />
      <CTASection />
      <Testimonials />
      <Footer />
    </main>
  );
}